export default __webpack_public_path__ + "static/media/GRANT_OIL_W.a5e72080.png";